<template>
  <div>
    <h3>{{item.name}}
      <span v-if="item.detail" class="subheader">{{item.detail}}</span>
    </h3>
    <div>
      <div v-if="item.weight"><strong>Weight:</strong> {{ item.weight }}</div>
      <div v-if="item.quantity"><strong>Quantity:</strong> {{ item.quantity }}</div>
      <div><strong>Carried:</strong> <span v-if="item.carried">Yes</span><span v-else>No</span></div>
      <div><strong>Equipped:</strong> <span v-if="item.equipped">Yes</span><span v-else>No</span></div>
    </div>
    
    <div v-if="item.description" v-html="$embers.markdown(item.description)"></div>

  </div>
</template>
<script>
export default {
  name: "sheet-items-display",
  props: ["item"]
};
</script>
